import { render } from "./EditProduct.vue?vue&type=template&id=6eb93795"
import script from "./EditProduct.vue?vue&type=script&lang=js"
export * from "./EditProduct.vue?vue&type=script&lang=js"

import "./EditProduct.vue?vue&type=style&index=0&id=6eb93795&lang=css"

import exportComponent from "E:\\Andrei\\munca\\Isoletta\\isoletta-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__